const topbar = {
    docs: 'Documentazione',
    help: 'Aiuto',
    /** UNTRANSLATED */
    subscription: 'Subscription',
};
export default Object.freeze(topbar);
